import { render, staticRenderFns } from "./ViewPatientVisits.vue?vue&type=template&id=87bc86c2&"
import script from "./ViewPatientVisits.vue?vue&type=script&lang=js&"
export * from "./ViewPatientVisits.vue?vue&type=script&lang=js&"
import style0 from "./ViewPatientVisits.vue?vue&type=style&index=0&id=87bc86c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports